// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Misma lógica que .recordings-page: columna que ocupa el área del layout sin desbordar el viewport */
.streams-content {
  flex: 1 1;
  min-height: 0;
  min-width: 0;
  height: 100%;
  max-height: 100%;
  width: 100%;
  max-width: 100%;
  padding: 0;
  background: #000;
  color: #fff;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.streams-shell {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  min-width: 0;
  height: 100%;
  max-height: 100%;
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  background: #000;
  transition: width 0.25s ease;
  box-sizing: border-box;
  /* Paleta alineada con Grabaciones / Analytics */
  --rx-toolbar: #0a0a0a;
  --rx-surface: #111111;
  --rx-slot: #0a0a0a;
  --rx-border: #374151;
  --rx-accent: #a61b34;
  --rx-accent-deep: #8b1528;
}

/* Cuando el menú de cámaras está abierto, la grilla cede espacio (no se superpone) */
.streams-shell.schema-sidebar-open {
  width: calc(100% - 320px);
  max-width: 100%;
}

.streams-schema-sidebar {
  --schema-width: 320px;
  --schema-pvvc: #3b82f6;
  --schema-privados: #f97316;
  --schema-eu: #E07054;
  --schema-masivos: #14b8a6;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: var(--schema-width);
  min-width: 0;
  min-height: 0;
  background: #111111;
  border-left: 1px solid #2d2d2d;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  transform: translateX(100%);
  transition: transform 0.25s ease;
}

.streams-schema-sidebar.open {
  transform: translateX(0);
}

.streams-schema-sidebar.collapsed {
  transform: translateX(100%);
}

.streams-schema-backdrop {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 9999;
  pointer-events: none;
}

.streams-schema-header {
  padding: 14px 12px 12px 12px;
  border-bottom: 1px solid #2d2d2d;
  background: #111111;
}

.streams-schema-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.streams-schema-title-icon {
  color: #9ca3af;
  flex-shrink: 0;
}

.streams-schema-title-text {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.streams-schema-search-wrap {
  position: relative;
  margin-top: 10px;
}

.streams-schema-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
}

.streams-schema-search {
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px 9px 34px;
  border: 1px solid #374151;
  border-radius: 8px;
  background: #0a0a0a;
  color: #ffffff;
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.streams-schema-search::placeholder {
  color: #6b7280;
}

.streams-schema-search:focus {
  border-color: #a61b34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.streams-schema-body {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 10px;
  background: #111111;
}

/* Portaled a body: colores literales (no hereda --rx-* de .streams-shell) */
.streams-schema-toggle {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 56px;
  border-radius: 10px 0 0 10px;
  border: 4px solid #a61b34;
  border-right: none;
  background: linear-gradient(135deg, #a61b34 0%, #8b1528 100%);
  color: #fecaca;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10001;
  transition: right 0.25s ease, background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  right: 0;
}

.streams-schema-toggle.open {
  right: 320px;
}

.streams-schema-toggle:hover {
  background: linear-gradient(135deg, #c42a45 0%, #a61b34 100%);
  border-color: #c42a45;
  color: #fff;
}

.schema-section {
  margin-bottom: 14px;
}

.schema-section-header {
  width: 100%;
  border: none;
  border-radius: 10px;
  padding: 10px 12px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font: inherit;
  text-align: left;
  transition: background 0.15s ease;
}

.schema-section-pvvc .schema-section-header {
  background: rgba(59, 130, 246, 0.15);
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.schema-section-privados .schema-section-header {
  background: rgba(249, 115, 22, 0.15);
  border: 1px solid rgba(249, 115, 22, 0.3);
}

.schema-section-eu .schema-section-header {
  background: rgba(224, 112, 84, 0.15);
  border: 1px solid rgba(224, 112, 84, 0.3);
}

.schema-section-masivos .schema-section-header {
  background: rgba(20, 184, 166, 0.15);
  border: 1px solid rgba(20, 184, 166, 0.35);
}

.schema-section-header:hover {
  filter: brightness(1.1);
}

.schema-section-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.schema-section-pvvc .schema-section-dot {
  background: var(--schema-pvvc);
}

.schema-section-privados .schema-section-dot {
  background: var(--schema-privados);
}

.schema-section-eu .schema-section-dot {
  background: var(--schema-eu);
}

.schema-section-masivos .schema-section-dot {
  background: var(--schema-masivos);
}

.schema-section-name {
  font-weight: 700;
  font-size: 13px;
  flex: 1 1;
}

.schema-section-count {
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 6px;
  color: #fff;
  min-width: 28px;
  text-align: center;
}

.schema-section-pvvc .schema-section-count {
  background: var(--schema-pvvc);
}

.schema-section-privados .schema-section-count {
  background: var(--schema-privados);
}

.schema-section-eu .schema-section-count {
  background: var(--schema-eu);
}

.schema-section-masivos .schema-section-count {
  background: var(--schema-masivos);
}

.schema-section-content {
  margin-top: 8px;
  padding-left: 4px;
}

.schema-chevron {
  transition: transform 0.15s ease;
  color: #9ca3af;
  flex-shrink: 0;
}

.schema-chevron.open {
  transform: rotate(180deg);
}

.schema-grip {
  color: #6b7280;
  flex-shrink: 0;
  cursor: grab;
}

.schema-site {
  margin-bottom: 6px;
}

.schema-site-header {
  width: 100%;
  background: #1a1a1a;
  border: 1px solid #3d3d3d;
  color: #e5e7eb;
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font: inherit;
  text-align: left;
  transition: border-color 0.15s, background 0.15s;
  border-left: 3px solid #6b7280;
}

.schema-site-header--online {
  border-left-color: #10B981;
}

.schema-site-header--partial {
  border-left-color: #F59E0B;
}

.schema-site-header--offline {
  border-left-color: #EF4444;
}

.schema-site-header--unknown {
  border-left-color: #6b7280;
}

.schema-section-pvvc .schema-site-header {
  background: rgba(59, 130, 246, 0.06);
}
.schema-section-privados .schema-site-header {
  background: rgba(249, 115, 22, 0.06);
}
.schema-section-eu .schema-site-header {
  background: rgba(224, 112, 84, 0.06);
}
.schema-section-masivos .schema-site-header {
  border-left-color: var(--schema-masivos);
  background: rgba(20, 184, 166, 0.06);
}

.schema-site-header:hover {
  background: #252525;
  border-color: #4b5563;
}
.schema-section-pvvc .schema-site-header:hover {
  background: rgba(59, 130, 246, 0.12);
}
.schema-section-privados .schema-site-header:hover {
  background: rgba(249, 115, 22, 0.12);
}
.schema-section-eu .schema-site-header:hover {
  background: rgba(224, 112, 84, 0.12);
}
.schema-section-masivos .schema-site-header:hover {
  border-left-color: var(--schema-masivos);
  background: rgba(20, 184, 166, 0.12);
}

.schema-site-header--online:hover {
  border-left-color: #10B981;
}

.schema-site-header--partial:hover {
  border-left-color: #F59E0B;
}

.schema-site-header--offline:hover {
  border-left-color: #EF4444;
}

.schema-site-header--unknown:hover {
  border-left-color: #6b7280;
}

.schema-site-header-draggable {
  cursor: grab;
}

.schema-site-header-draggable:active {
  cursor: grabbing;
}

.schema-site-name {
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}

.schema-section-pvvc .schema-site-name { color: var(--schema-pvvc); }
.schema-section-privados .schema-site-name { color: var(--schema-privados); }
.schema-section-eu .schema-site-name { color: var(--schema-eu); }
.schema-section-masivos .schema-site-name { color: var(--schema-masivos); }

.schema-site-cam-count {
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

.schema-site-cam-total {
  color: #6b7280;
  font-weight: 400;
}

.schema-section-masivos .schema-site-cam-count {
  color: var(--schema-masivos);
}

.schema-cameras {
  margin-top: 6px;
  padding-left: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.schema-camera {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #1a1a1a;
  border: 1px solid #3d3d3d;
  cursor: grab;
  transition: border-color 0.15s, background 0.15s;
}

.schema-camera:hover {
  border-color: #4b5563;
  background: #252525;
}

.schema-camera:active {
  cursor: grabbing;
}

.schema-camera-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.schema-camera-name {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schema-camera-address {
  font-size: 11px;
  color: #9ca3af;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schema-camera-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  flex-shrink: 0;
  color: #fff;
}

.schema-section-pvvc .schema-camera-badge {
  background: var(--schema-pvvc);
}

.schema-section-privados .schema-camera-badge {
  background: var(--schema-privados);
}

.schema-section-eu .schema-camera-badge {
  background: var(--schema-eu);
}

.schema-section-masivos .schema-camera-badge {
  background: var(--schema-masivos);
}

.schema-camera-status {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.35);
}

.schema-camera-status--on {
  background: #22c55e;
}

.schema-camera-status--off {
  background: #dc2626;
}

.schema-camera-status--issue {
  background: #f97316;
}

.schema-camera-status--unknown {
  background: #6b7280;
}

.schema-camera--off {
  opacity: 0.72;
}

.schema-camera--off .schema-camera-name {
  color: #d1d5db;
}

.schema-camera--issue .schema-camera-name {
  color: #fdba74;
}

.schema-camera-warn {
  color: #f87171;
  flex-shrink: 0;
}

/* Cámara con bocina en el mismo poste */
.schema-camera-siren {
  display: inline-flex;
  align-items: center;
  color: #38bdf8;
  flex-shrink: 0;
}

.schema-empty {
  color: #9ca3af;
  font-size: 12px;
  padding: 8px 10px;
}

.schema-hint {
  margin-top: 10px;
  font-size: 12px;
  color: #9ca3af;
  padding: 10px;
  border-radius: 8px;
  border: 1px dashed #3d3d3d;
  background: rgba(255, 255, 255, 0.03);
}

.schema-no-results {
  color: #6b7280;
  font-style: italic;
}

.streams-content.loading {
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255,255,255,0.1);
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Header: misma franja que .recordings-header */
.streams-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 0;
  flex-shrink: 0;
  flex-wrap: wrap;
  background: var(--rx-toolbar);
  border-bottom: 1px solid #1f2937;
  min-height: 49px;
  box-sizing: border-box;
}

.streams-header-left {
  display: flex;
  align-items: center;
}

.streams-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
  justify-content: flex-end;
}

.streams-fullscreen-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: #e5e7eb;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
}

.streams-fullscreen-btn:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.35);
  color: #fff;
}

.layout-controls .layout-clear-grid-btn {
  margin-left: 6px;
}

.layout-btn:disabled,
.layout-btn:disabled:hover {
  opacity: 0.45;
  cursor: not-allowed;
  background: #2a2d35;
  border-color: #3d3d3d;
  color: #999;
}

.streams-header-search {
  width: 100%;
  max-width: 360px;
  min-width: 180px;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.search-icon-inner {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
  flex-shrink: 0;
}

/* Mismo criterio que .sites-search-input (Sitios) */
.search-input {
  width: 100%;
  min-width: 0;
  padding: 10px 12px 10px 38px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #374151;
  background: #0a0a0a;
  color: #ffffff;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.search-input::placeholder {
  color: #6b7280;
}

.search-input:focus {
  border-color: #a61b34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.site-select {
  background: #2d2d2d;
  border: 1px solid #3d3d3d;
  color: #ffffff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.stream-mode-select {
  background: #2d2d2d;
  border: 1px solid #3d3d3d;
  color: #ffffff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.2s;
}

.stream-mode-select:focus {
  outline: none;
  border-color: #A61B34;
}

.site-select:focus {
  outline: none;
  border-color: #A61B34;
}

/* Área de grilla: como Grabaciones — grid 1fr para altura definida (evita bandas negras “entre filas”
   por filas auto + aspect-ratio que no reparten el alto del viewport). El banner de cámaras es absolute. */
.streams-view-right {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  width: 100%;
  flex: 1 1;
  min-height: 0;
  min-width: 0;
  max-height: 100%;
  position: relative;
  padding: 10px;
  /* Sin scroll: los slots se encogen para caber en el viewport disponible. */
  overflow: hidden;
  box-sizing: border-box;
}

.streams-view-right .video-grid {
  width: 100%;
  max-width: 100%;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  align-self: stretch;
  justify-self: stretch;
}


.streams-header .layout-controls {
  margin-bottom: 0;
}

.layout-controls {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
}

.layout-label {
  color: #999;
  font-size: 13px;
  margin-right: 4px;
}

.layout-btn {
  background: var(--rx-surface);
  border: 1px solid var(--rx-border);
  color: #9ca3af;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  min-height: 38px;
  box-sizing: border-box;
  overflow: hidden;
}

.layout-btn:hover {
  background: #1f2937;
  border-color: #6b7280;
  color: #fff;
}

.layout-btn.active {
  background: var(--rx-accent);
  border-color: var(--rx-accent);
  color: #fff;
}

/* Iconos: tamaño acotado al interior del botón (p. ej. 38px − padding) y celdas en 1fr
   para que en viewports estrechos o padding reducido no desborden el borde. */
.layout-icon {
  display: grid;
  gap: 2px;
  width: 22px;
  height: 22px;
  max-width: 100%;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
}

.layout-icon-1x1 {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
}

/* Una sola celda: debe llenar el área (auto + aspect-ratio dejaba la celda en 0×0 en algunos navegadores). */
.layout-icon-1x1 .layout-icon-cell {
  width: 100%;
  height: 100%;
  aspect-ratio: unset;
  border-radius: 3px;
}

.layout-icon-2x2 {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.layout-icon-3x2 {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.layout-icon-3x3 {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.layout-icon-4x3 {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.layout-icon-4x4 {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
}

/* Icono vista vigilancia: 1 grande + 3 apiladas + 4 abajo */
.layout-icon-surveillance-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  max-width: 100%;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
  padding: 0;
  box-sizing: border-box;
}

.layout-icon-surveillance {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 2px;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  border-radius: 2px;
  overflow: hidden;
}

.layout-icon-surveillance .layout-icon-panel {
  min-width: 0;
  min-height: 0;
  border-radius: 1px;
  background: currentColor;
  opacity: 0.8;
}

.layout-btn.active .layout-icon-surveillance .layout-icon-panel {
  opacity: 1;
}

.layout-icon-surveillance .layout-icon-surv-main {
  grid-column: 1 / 4;
  grid-row: 1 / 4;
}

.layout-icon-surveillance .layout-icon-surv-stack:nth-child(2) {
  grid-column: 4;
  grid-row: 1;
}

.layout-icon-surveillance .layout-icon-surv-stack:nth-child(3) {
  grid-column: 4;
  grid-row: 2;
}

.layout-icon-surveillance .layout-icon-surv-stack:nth-child(4) {
  grid-column: 4;
  grid-row: 3;
}

.layout-icon-surveillance .layout-icon-surv-bottom:nth-child(5) {
  grid-column: 1;
  grid-row: 4;
}

.layout-icon-surveillance .layout-icon-surv-bottom:nth-child(6) {
  grid-column: 2;
  grid-row: 4;
}

.layout-icon-surveillance .layout-icon-surv-bottom:nth-child(7) {
  grid-column: 3;
  grid-row: 4;
}

.layout-icon-surveillance .layout-icon-surv-bottom:nth-child(8) {
  grid-column: 4;
  grid-row: 4;
}

.layout-icon-cell {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  border-radius: 1px;
  background: currentColor;
  opacity: 0.75;
}

.layout-btn.active .layout-icon-cell {
  opacity: 1;
}

/* Camera selector */
.camera-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
  background: rgba(255,255,255,0.03);
  border-radius: 8px;
}

.selector-label {
  color: #6b7280;
  font-size: 13px;
  margin-right: 8px;
}

.camera-chip {
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.1);
  color: #9ca3af;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.camera-chip:hover {
  background: rgba(255,255,255,0.15);
  color: #fff;
}

.camera-chip.selected {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #fff;
}

.camera-chip.clear {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.3);
  color: #fca5a5;
}

.camera-chip.clear:hover {
  background: rgba(239, 68, 68, 0.3);
}

/* Video Grid — filas/columnas 1fr reparten el alto disponible; el vídeo rellena la celda (VideoCard). */
.video-grid {
  display: grid;
  column-gap: 8px;
  row-gap: 8px;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  align-content: stretch;
}

/* Una sola cámara */
.video-grid.layout-1 {
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  justify-items: stretch;
  align-content: stretch;
  min-height: 0;
}
.video-grid.layout-1 > * {
  width: 100%;
  height: 100%;
  min-height: 0;
  max-width: 100%;
  max-height: 100%;
  aspect-ratio: unset;
}

/* ---------- Vista enfocada (doble clic en slot → 1x1) ---------- */

/* El grid deja de recortar para que el slot enfocado pueda salir de él */
.video-grid.video-grid-focused {
  overflow: visible !important;
}

/* El slot enfocado se posiciona sobre .streams-view-right (el ancestro con position:relative)
   porque .video-grid no tiene position, así que absolute va al siguiente ancestro posicionado. */
.video-grid.video-grid-focused > .grid-slot-focused {
  position: absolute !important;
  inset: 0 !important;
  z-index: 50;
  width: auto !important;
  height: auto !important;
  aspect-ratio: auto !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  background: #1a1a1a;
}

/* VideoCard y video: llenan todo el slot enfocado */
.video-grid.video-grid-focused > .grid-slot-focused > .video-card {
  flex: 1 1 !important;
  min-height: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.video-grid.video-grid-focused > .grid-slot-focused .video-container {
  flex: 1 1 !important;
  min-height: 0 !important;
}

/* Los demás slots quedan montados (videos cargados) pero invisibles */
.video-grid.video-grid-focused > .grid-slot:not(.grid-slot-focused),
.video-grid.video-grid-focused > .empty-slot:not(.grid-slot-focused) {
  visibility: hidden !important;
}

/* Hint sobre el slot enfocado */
.video-grid-focused-hint {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 11px;
  pointer-events: none;
  z-index: 51;
}

.video-grid.layout-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
}

.video-grid.layout-3x2 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
}

.video-grid.layout-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: repeat(3, minmax(0, 1fr));
}

.video-grid.layout-4x3 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: repeat(3, minmax(0, 1fr));
}

.video-grid.layout-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: repeat(4, minmax(0, 1fr));
}

/* Vista vigilancia: 1 principal (grande) + 3 apiladas derecha + 4 abajo */
.video-grid.layout-surveillance {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: repeat(3, minmax(0, 1fr)) minmax(0, 1fr);
}

.video-grid.layout-surveillance > * {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.video-grid.layout-surveillance > *:nth-child(1) {
  grid-column: 1 / 4;
  grid-row: 1 / 4;
}

.video-grid.layout-surveillance > *:nth-child(2) {
  grid-column: 4;
  grid-row: 1;
}

.video-grid.layout-surveillance > *:nth-child(3) {
  grid-column: 4;
  grid-row: 2;
}

.video-grid.layout-surveillance > *:nth-child(4) {
  grid-column: 4;
  grid-row: 3;
}

.video-grid.layout-surveillance > *:nth-child(5) {
  grid-column: 1;
  grid-row: 4;
}

.video-grid.layout-surveillance > *:nth-child(6) {
  grid-column: 2;
  grid-row: 4;
}

.video-grid.layout-surveillance > *:nth-child(7) {
  grid-column: 3;
  grid-row: 4;
}

.video-grid.layout-surveillance > *:nth-child(8) {
  grid-column: 4;
  grid-row: 4;
}

.empty-slot {
  background: var(--rx-slot);
  border: 2px dashed var(--rx-border);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  transition: all 0.2s;
}

.empty-slot:hover {
  border-color: var(--rx-accent);
  background: rgba(166, 27, 52, 0.05);
}

.empty-slot-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  text-align: center;
}

.empty-slot-icon {
  width: 48px;
  height: 48px;
  color: #4b5563;
}

.empty-slot-icon svg {
  width: 100%;
  height: 100%;
}

.empty-slot-text {
  font-size: 13px;
  color: #9ca3af;
}

.empty-slot-number {
  font-size: 11px;
  color: #6b7280;
  margin-top: 4px;
}

/* Banner de cámaras disponibles (flotante, no ocupa espacio en el layout) */
.cameras-banner {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 20;
  width: 260px;
  max-height: 200px;
  background: #2d2d2d;
  border: 1px solid #3d3d3d;
  border-radius: 8px;
  padding: 12px;
  overflow-y: auto;
  animation: slideDown 0.3s ease-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.banner-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.banner-header h3 {
  margin: 0;
  font-size: 14px;
  color: #fff;
  font-weight: 600;
}

.close-banner-btn {
  background: transparent;
  border: none;
  color: #999;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.close-banner-btn:hover {
  color: #fff;
}

.cameras-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
}

.camera-item {
  background: #1a1a1a;
  border: 1px solid #3d3d3d;
  border-radius: 6px;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: grab;
  transition: all 0.2s;
}

.camera-item:active {
  cursor: grabbing;
}

.camera-item:hover {
  border-color: #A61B34;
  background: rgba(166, 27, 52, 0.05);
}

.camera-item-icon {
  font-size: 24px;
}

.camera-item-info {
  flex: 1 1;
  min-width: 0;
}

.camera-item-name {
  font-weight: 600;
  color: #fff;
  font-size: 14px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.camera-item-address {
  color: #999;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.camera-item-badge {
  background: #3d3d3d;
  color: #999;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.camera-item-badge--on {
  background: rgba(34, 197, 94, 0.16);
  color: #86efac;
}

.camera-item-badge--off {
  background: rgba(220, 38, 38, 0.16);
  color: #fca5a5;
}

.camera-item-badge--issue {
  background: rgba(249, 115, 22, 0.16);
  color: #fdba74;
}

.camera-item-badge--unknown {
  background: rgba(107, 114, 128, 0.2);
  color: #d1d5db;
}

.camera-item--off {
  opacity: 0.78;
}

.camera-item--off .camera-item-name {
  color: #d1d5db;
}

.grid-slot {
  position: relative;
  width: 100%;
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Solo slots con overlay bajo demanda: evita contain en todas las celdas con VideoCard */
.grid-slot--on-demand-frozen {
  container-type: size;
  container-name: stream-slot;
}

/* remove-camera-btn moved into VideoCard header */

.loading-cameras {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  min-height: 120px;
}

.no-cameras-found {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
}

/* Celdas: llenan la pista 1fr (el alto lo marca el contenedor, no aspect-ratio + max-height sueltos). */
.video-grid:not(.layout-1):not(.layout-surveillance):not(.video-grid-focused) > * {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  max-width: 100%;
  max-height: 100%;
  aspect-ratio: unset;
  overflow: hidden;
  box-sizing: border-box;
  align-self: stretch;
}

@media (max-width: 1200px) {
  .layout-controls {
    flex-wrap: wrap;
  }
  
  .layout-btn {
    font-size: 12px;
    padding: 5px 8px;
    min-width: 35px;
  }
}

@media (max-width: 768px) {
  .streams-header {
    flex-direction: column;
    align-items: stretch;
  }

  .streams-header-left {
    order: 1;
  }

  .streams-header-right {
    order: 2;
    width: 100%;
  }

  .streams-header-search {
    max-width: none;
    width: 100%;
  }

  .search-container {
    flex: 1 1;
    min-width: 0;
    max-width: none;
  }

  .search-input {
    flex: 1 1;
    min-width: 0;
  }

  .streams-view-right {
    align-items: stretch;
  }

  .streams-header .layout-controls {
    width: 100%;
    justify-content: center;
  }

  .streams-schema-sidebar {
    --schema-width: min(86vw, 340px);
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
  }

  .streams-schema-toggle {
    z-index: 10001;
  }

  .streams-schema-toggle.open {
    right: min(86vw, 340px);
  }
}

/* ── Overlay "¿Quieres seguir viendo?" (bajo demanda) ── */
.on-demand-screenshot {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.on-demand-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(2px);
  animation: onDemandFadeIn 0.4s ease;
  box-sizing: border-box;
  padding: 4px;
  padding: clamp(2px, 1.2cqmin, 10px);
  min-height: 0;
}

@keyframes onDemandFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.on-demand-overlay-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 8px;
  gap: clamp(4px, 1.5cqmin, 10px);
  padding: 14px 16px;
  padding: clamp(6px, 3cqmin, 24px) clamp(8px, 3.5cqmin, 28px);
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  max-height: 100%;
  min-height: 0;
}

/* Texto e icono: zona que puede hacer scroll si el slot es muy bajo; botones quedan visibles abajo */
.on-demand-overlay-body {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  gap: clamp(3px, 1.2cqmin, 10px);
  scrollbar-width: thin;
}

.on-demand-overlay-icon {
  width: 36px;
  height: 36px;
  width: clamp(22px, 10cqmin, 48px);
  height: clamp(22px, 10cqmin, 48px);
  flex-shrink: 0;
  color: #dc2626;
  margin-bottom: 0;
}

.on-demand-overlay-icon svg {
  width: 100%;
  height: 100%;
}

.on-demand-overlay-site {
  font-size: 13px;
  font-size: clamp(10px, 2.8cqmin + 0.35rem, 16px);
  font-weight: 700;
  color: #dc2626;
  max-width: 100%;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.on-demand-overlay-text {
  font-size: 12px;
  font-size: clamp(9px, 2.2cqmin + 0.28rem, 13px);
  color: #d1d5db;
  line-height: 1.45;
  max-width: 100%;
  min-width: 0;
  width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
}

.on-demand-overlay-question {
  font-size: 12px;
  font-size: clamp(10px, 2.4cqmin + 0.3rem, 14px);
  font-weight: 600;
  color: #fff;
  max-width: 100%;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.on-demand-overlay-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  gap: clamp(6px, 2cqmin, 10px);
  flex-shrink: 0;
  width: 100%;
  margin-top: 0;
}

.on-demand-btn {
  padding: 6px 14px;
  padding: clamp(5px, 1.2cqmin, 8px) clamp(10px, 3cqmin, 20px);
  border-radius: 8px;
  border-radius: clamp(5px, 1cqmin, 8px);
  font-size: 12px;
  font-size: clamp(10px, 2.1cqmin + 0.25rem, 13px);
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 0.15s ease, transform 0.1s ease;
  flex: 1 1 auto;
  min-width: min(100%, 4.5em);
  max-width: 100%;
  box-sizing: border-box;
}

/* Slots estrechos o bajos: botones en columna para no recortar */
@container stream-slot (max-width: 260px) {
  .on-demand-overlay-actions {
    flex-direction: column;
  }

  .on-demand-btn {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
}

@container stream-slot (max-height: 200px) {
  .on-demand-overlay-actions {
    flex-direction: column;
  }

  .on-demand-btn {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
}

/* Muy poca altura: ocultar icono para priorizar texto + botones */
@container stream-slot (max-height: 120px) {
  .on-demand-overlay-icon {
    display: none;
  }

  .on-demand-overlay-content {
    gap: 4px;
    padding: 4px 6px;
  }
}

.on-demand-btn:active {
  transform: scale(0.97);
}

.on-demand-btn-yes {
  background: rgba(255, 255, 255, 0.12);
  color: #d1d5db;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.on-demand-btn-yes:hover {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.on-demand-btn-no {
  background: rgba(255, 255, 255, 0.1);
  color: #9ca3af;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.on-demand-btn-no:hover {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/StreamsPage.css"],"names":[],"mappings":"AAAA,sGAAsG;AACtG;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,gDAAgD;EAChD,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,qFAAqF;AACrF;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,8FAA8F;EAC9F,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA,yCAAyC,yBAAyB,EAAE;AACpE,6CAA6C,6BAA6B,EAAE;AAC5E,uCAAuC,uBAAuB,EAAE;AAChE,4CAA4C,4BAA4B,EAAE;;AAE1E;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;2GAC2G;AAC3G;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,WAAW;EACX,SAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,2EAA2E;EAC3E,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;8EAC8E;AAC9E;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,6GAA6G;AAC7G;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,wGAAwG;AACxG;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oEAAoE;;AAEpE,yEAAyE;AACzE;EACE,4BAA4B;AAC9B;;AAEA;iGACiG;AACjG;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,oBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,sEAAsE;AACtE;;EAEE,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA,0EAA0E;AAC1E;EACE,gDAAgD;EAChD,4DAA4D;AAC9D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,yFAAyF;AACzF;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,kDAAkD;;AAElD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,wGAAwG;AACxG;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,mCAAmC;EACnC,sBAAsB;EACtB,YAAY;EACZ,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,QAAQ;EACR,+BAA+B;EAC/B,kBAAkB;EAClB,4DAA4D;EAC5D,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA,qGAAqG;AACrG;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;EAClC,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+CAA+C;EAC/C,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,+CAA+C;EAC/C,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,4DAA4D;EAC5D,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sDAAsD;EACtD,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;AACxB;;AAEA,iEAAiE;AACjE;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,kEAAkE;AAClE;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb","sourcesContent":["/* Misma lógica que .recordings-page: columna que ocupa el área del layout sin desbordar el viewport */\n.streams-content {\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  height: 100%;\n  max-height: 100%;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  background: #000;\n  color: #fff;\n  overflow: hidden;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.streams-shell {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  height: 100%;\n  max-height: 100%;\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  overflow: hidden;\n  background: #000;\n  transition: width 0.25s ease;\n  box-sizing: border-box;\n  /* Paleta alineada con Grabaciones / Analytics */\n  --rx-toolbar: #0a0a0a;\n  --rx-surface: #111111;\n  --rx-slot: #0a0a0a;\n  --rx-border: #374151;\n  --rx-accent: #a61b34;\n  --rx-accent-deep: #8b1528;\n}\n\n/* Cuando el menú de cámaras está abierto, la grilla cede espacio (no se superpone) */\n.streams-shell.schema-sidebar-open {\n  width: calc(100% - 320px);\n  max-width: 100%;\n}\n\n.streams-schema-sidebar {\n  --schema-width: 320px;\n  --schema-pvvc: #3b82f6;\n  --schema-privados: #f97316;\n  --schema-eu: #E07054;\n  --schema-masivos: #14b8a6;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: var(--schema-width);\n  min-width: 0;\n  min-height: 0;\n  background: #111111;\n  border-left: 1px solid #2d2d2d;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  z-index: 10000;\n  transform: translateX(100%);\n  transition: transform 0.25s ease;\n}\n\n.streams-schema-sidebar.open {\n  transform: translateX(0);\n}\n\n.streams-schema-sidebar.collapsed {\n  transform: translateX(100%);\n}\n\n.streams-schema-backdrop {\n  position: fixed;\n  inset: 0;\n  background: transparent;\n  z-index: 9999;\n  pointer-events: none;\n}\n\n.streams-schema-header {\n  padding: 14px 12px 12px 12px;\n  border-bottom: 1px solid #2d2d2d;\n  background: #111111;\n}\n\n.streams-schema-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.streams-schema-title-icon {\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n.streams-schema-title-text {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.streams-schema-search-wrap {\n  position: relative;\n  margin-top: 10px;\n}\n\n.streams-schema-search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  pointer-events: none;\n}\n\n.streams-schema-search {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 9px 12px 9px 34px;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  background: #0a0a0a;\n  color: #ffffff;\n  font-size: 13px;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.streams-schema-search::placeholder {\n  color: #6b7280;\n}\n\n.streams-schema-search:focus {\n  border-color: #a61b34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.streams-schema-body {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 10px;\n  background: #111111;\n}\n\n/* Portaled a body: colores literales (no hereda --rx-* de .streams-shell) */\n.streams-schema-toggle {\n  position: fixed;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 28px;\n  height: 56px;\n  border-radius: 10px 0 0 10px;\n  border: 4px solid #a61b34;\n  border-right: none;\n  background: linear-gradient(135deg, #a61b34 0%, #8b1528 100%);\n  color: #fecaca;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10001;\n  transition: right 0.25s ease, background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  right: 0;\n}\n\n.streams-schema-toggle.open {\n  right: 320px;\n}\n\n.streams-schema-toggle:hover {\n  background: linear-gradient(135deg, #c42a45 0%, #a61b34 100%);\n  border-color: #c42a45;\n  color: #fff;\n}\n\n.schema-section {\n  margin-bottom: 14px;\n}\n\n.schema-section-header {\n  width: 100%;\n  border: none;\n  border-radius: 10px;\n  padding: 10px 12px;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  transition: background 0.15s ease;\n}\n\n.schema-section-pvvc .schema-section-header {\n  background: rgba(59, 130, 246, 0.15);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n.schema-section-privados .schema-section-header {\n  background: rgba(249, 115, 22, 0.15);\n  border: 1px solid rgba(249, 115, 22, 0.3);\n}\n\n.schema-section-eu .schema-section-header {\n  background: rgba(224, 112, 84, 0.15);\n  border: 1px solid rgba(224, 112, 84, 0.3);\n}\n\n.schema-section-masivos .schema-section-header {\n  background: rgba(20, 184, 166, 0.15);\n  border: 1px solid rgba(20, 184, 166, 0.35);\n}\n\n.schema-section-header:hover {\n  filter: brightness(1.1);\n}\n\n.schema-section-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.schema-section-pvvc .schema-section-dot {\n  background: var(--schema-pvvc);\n}\n\n.schema-section-privados .schema-section-dot {\n  background: var(--schema-privados);\n}\n\n.schema-section-eu .schema-section-dot {\n  background: var(--schema-eu);\n}\n\n.schema-section-masivos .schema-section-dot {\n  background: var(--schema-masivos);\n}\n\n.schema-section-name {\n  font-weight: 700;\n  font-size: 13px;\n  flex: 1;\n}\n\n.schema-section-count {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 6px;\n  color: #fff;\n  min-width: 28px;\n  text-align: center;\n}\n\n.schema-section-pvvc .schema-section-count {\n  background: var(--schema-pvvc);\n}\n\n.schema-section-privados .schema-section-count {\n  background: var(--schema-privados);\n}\n\n.schema-section-eu .schema-section-count {\n  background: var(--schema-eu);\n}\n\n.schema-section-masivos .schema-section-count {\n  background: var(--schema-masivos);\n}\n\n.schema-section-content {\n  margin-top: 8px;\n  padding-left: 4px;\n}\n\n.schema-chevron {\n  transition: transform 0.15s ease;\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n.schema-chevron.open {\n  transform: rotate(180deg);\n}\n\n.schema-grip {\n  color: #6b7280;\n  flex-shrink: 0;\n  cursor: grab;\n}\n\n.schema-site {\n  margin-bottom: 6px;\n}\n\n.schema-site-header {\n  width: 100%;\n  background: #1a1a1a;\n  border: 1px solid #3d3d3d;\n  color: #e5e7eb;\n  border-radius: 8px;\n  padding: 8px 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  transition: border-color 0.15s, background 0.15s;\n  border-left: 3px solid #6b7280;\n}\n\n.schema-site-header--online {\n  border-left-color: #10B981;\n}\n\n.schema-site-header--partial {\n  border-left-color: #F59E0B;\n}\n\n.schema-site-header--offline {\n  border-left-color: #EF4444;\n}\n\n.schema-site-header--unknown {\n  border-left-color: #6b7280;\n}\n\n.schema-section-pvvc .schema-site-header {\n  background: rgba(59, 130, 246, 0.06);\n}\n.schema-section-privados .schema-site-header {\n  background: rgba(249, 115, 22, 0.06);\n}\n.schema-section-eu .schema-site-header {\n  background: rgba(224, 112, 84, 0.06);\n}\n.schema-section-masivos .schema-site-header {\n  border-left-color: var(--schema-masivos);\n  background: rgba(20, 184, 166, 0.06);\n}\n\n.schema-site-header:hover {\n  background: #252525;\n  border-color: #4b5563;\n}\n.schema-section-pvvc .schema-site-header:hover {\n  background: rgba(59, 130, 246, 0.12);\n}\n.schema-section-privados .schema-site-header:hover {\n  background: rgba(249, 115, 22, 0.12);\n}\n.schema-section-eu .schema-site-header:hover {\n  background: rgba(224, 112, 84, 0.12);\n}\n.schema-section-masivos .schema-site-header:hover {\n  border-left-color: var(--schema-masivos);\n  background: rgba(20, 184, 166, 0.12);\n}\n\n.schema-site-header--online:hover {\n  border-left-color: #10B981;\n}\n\n.schema-site-header--partial:hover {\n  border-left-color: #F59E0B;\n}\n\n.schema-site-header--offline:hover {\n  border-left-color: #EF4444;\n}\n\n.schema-site-header--unknown:hover {\n  border-left-color: #6b7280;\n}\n\n.schema-site-header-draggable {\n  cursor: grab;\n}\n\n.schema-site-header-draggable:active {\n  cursor: grabbing;\n}\n\n.schema-site-name {\n  font-size: 12px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.schema-section-pvvc .schema-site-name { color: var(--schema-pvvc); }\n.schema-section-privados .schema-site-name { color: var(--schema-privados); }\n.schema-section-eu .schema-site-name { color: var(--schema-eu); }\n.schema-section-masivos .schema-site-name { color: var(--schema-masivos); }\n\n.schema-site-cam-count {\n  font-size: 11px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.schema-site-cam-total {\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.schema-section-masivos .schema-site-cam-count {\n  color: var(--schema-masivos);\n}\n\n.schema-cameras {\n  margin-top: 6px;\n  padding-left: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.schema-camera {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #1a1a1a;\n  border: 1px solid #3d3d3d;\n  cursor: grab;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.schema-camera:hover {\n  border-color: #4b5563;\n  background: #252525;\n}\n\n.schema-camera:active {\n  cursor: grabbing;\n}\n\n.schema-camera-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.schema-camera-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.schema-camera-address {\n  font-size: 11px;\n  color: #9ca3af;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.schema-camera-badge {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 4px;\n  flex-shrink: 0;\n  color: #fff;\n}\n\n.schema-section-pvvc .schema-camera-badge {\n  background: var(--schema-pvvc);\n}\n\n.schema-section-privados .schema-camera-badge {\n  background: var(--schema-privados);\n}\n\n.schema-section-eu .schema-camera-badge {\n  background: var(--schema-eu);\n}\n\n.schema-section-masivos .schema-camera-badge {\n  background: var(--schema-masivos);\n}\n\n.schema-camera-status {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.35);\n}\n\n.schema-camera-status--on {\n  background: #22c55e;\n}\n\n.schema-camera-status--off {\n  background: #dc2626;\n}\n\n.schema-camera-status--issue {\n  background: #f97316;\n}\n\n.schema-camera-status--unknown {\n  background: #6b7280;\n}\n\n.schema-camera--off {\n  opacity: 0.72;\n}\n\n.schema-camera--off .schema-camera-name {\n  color: #d1d5db;\n}\n\n.schema-camera--issue .schema-camera-name {\n  color: #fdba74;\n}\n\n.schema-camera-warn {\n  color: #f87171;\n  flex-shrink: 0;\n}\n\n/* Cámara con bocina en el mismo poste */\n.schema-camera-siren {\n  display: inline-flex;\n  align-items: center;\n  color: #38bdf8;\n  flex-shrink: 0;\n}\n\n.schema-empty {\n  color: #9ca3af;\n  font-size: 12px;\n  padding: 8px 10px;\n}\n\n.schema-hint {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #9ca3af;\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px dashed #3d3d3d;\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.schema-no-results {\n  color: #6b7280;\n  font-style: italic;\n}\n\n.streams-content.loading {\n  justify-content: center;\n  align-items: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(255,255,255,0.1);\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Header: misma franja que .recordings-header */\n.streams-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  margin-bottom: 0;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  background: var(--rx-toolbar);\n  border-bottom: 1px solid #1f2937;\n  min-height: 49px;\n  box-sizing: border-box;\n}\n\n.streams-header-left {\n  display: flex;\n  align-items: center;\n}\n\n.streams-header-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n  justify-content: flex-end;\n}\n\n.streams-fullscreen-btn {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #e5e7eb;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s, color 0.2s;\n}\n\n.streams-fullscreen-btn:hover {\n  background: rgba(255, 255, 255, 0.14);\n  border-color: rgba(255, 255, 255, 0.35);\n  color: #fff;\n}\n\n.layout-controls .layout-clear-grid-btn {\n  margin-left: 6px;\n}\n\n.layout-btn:disabled,\n.layout-btn:disabled:hover {\n  opacity: 0.45;\n  cursor: not-allowed;\n  background: #2a2d35;\n  border-color: #3d3d3d;\n  color: #999;\n}\n\n.streams-header-search {\n  width: 100%;\n  max-width: 360px;\n  min-width: 180px;\n}\n\n.search-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.search-icon-inner {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  pointer-events: none;\n  flex-shrink: 0;\n}\n\n/* Mismo criterio que .sites-search-input (Sitios) */\n.search-input {\n  width: 100%;\n  min-width: 0;\n  padding: 10px 12px 10px 38px;\n  font-size: 14px;\n  border-radius: 8px;\n  border: 1px solid #374151;\n  background: #0a0a0a;\n  color: #ffffff;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.search-input::placeholder {\n  color: #6b7280;\n}\n\n.search-input:focus {\n  border-color: #a61b34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.site-select {\n  background: #2d2d2d;\n  border: 1px solid #3d3d3d;\n  color: #ffffff;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.stream-mode-select {\n  background: #2d2d2d;\n  border: 1px solid #3d3d3d;\n  color: #ffffff;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n\n.stream-mode-select:focus {\n  outline: none;\n  border-color: #A61B34;\n}\n\n.site-select:focus {\n  outline: none;\n  border-color: #A61B34;\n}\n\n/* Área de grilla: como Grabaciones — grid 1fr para altura definida (evita bandas negras “entre filas”\n   por filas auto + aspect-ratio que no reparten el alto del viewport). El banner de cámaras es absolute. */\n.streams-view-right {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr);\n  width: 100%;\n  flex: 1 1 0%;\n  min-height: 0;\n  min-width: 0;\n  max-height: 100%;\n  position: relative;\n  padding: 10px;\n  /* Sin scroll: los slots se encogen para caber en el viewport disponible. */\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.streams-view-right .video-grid {\n  width: 100%;\n  max-width: 100%;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  align-self: stretch;\n  justify-self: stretch;\n}\n\n\n.streams-header .layout-controls {\n  margin-bottom: 0;\n}\n\n.layout-controls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 0;\n}\n\n.layout-label {\n  color: #999;\n  font-size: 13px;\n  margin-right: 4px;\n}\n\n.layout-btn {\n  background: var(--rx-surface);\n  border: 1px solid var(--rx-border);\n  color: #9ca3af;\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 38px;\n  min-height: 38px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.layout-btn:hover {\n  background: #1f2937;\n  border-color: #6b7280;\n  color: #fff;\n}\n\n.layout-btn.active {\n  background: var(--rx-accent);\n  border-color: var(--rx-accent);\n  color: #fff;\n}\n\n/* Iconos: tamaño acotado al interior del botón (p. ej. 38px − padding) y celdas en 1fr\n   para que en viewports estrechos o padding reducido no desborden el borde. */\n.layout-icon {\n  display: grid;\n  gap: 2px;\n  width: 22px;\n  height: 22px;\n  max-width: 100%;\n  max-height: 100%;\n  min-width: 0;\n  min-height: 0;\n  box-sizing: border-box;\n}\n\n.layout-icon-1x1 {\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n}\n\n/* Una sola celda: debe llenar el área (auto + aspect-ratio dejaba la celda en 0×0 en algunos navegadores). */\n.layout-icon-1x1 .layout-icon-cell {\n  width: 100%;\n  height: 100%;\n  aspect-ratio: unset;\n  border-radius: 3px;\n}\n\n.layout-icon-2x2 {\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n}\n\n.layout-icon-3x2 {\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n}\n\n.layout-icon-3x3 {\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(3, 1fr);\n}\n\n.layout-icon-4x3 {\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: repeat(3, 1fr);\n}\n\n.layout-icon-4x4 {\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: repeat(4, 1fr);\n}\n\n/* Icono vista vigilancia: 1 grande + 3 apiladas + 4 abajo */\n.layout-icon-surveillance-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  max-width: 100%;\n  max-height: 100%;\n  min-width: 0;\n  min-height: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.layout-icon-surveillance {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: repeat(4, 1fr);\n  gap: 2px;\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  min-height: 0;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.layout-icon-surveillance .layout-icon-panel {\n  min-width: 0;\n  min-height: 0;\n  border-radius: 1px;\n  background: currentColor;\n  opacity: 0.8;\n}\n\n.layout-btn.active .layout-icon-surveillance .layout-icon-panel {\n  opacity: 1;\n}\n\n.layout-icon-surveillance .layout-icon-surv-main {\n  grid-column: 1 / 4;\n  grid-row: 1 / 4;\n}\n\n.layout-icon-surveillance .layout-icon-surv-stack:nth-child(2) {\n  grid-column: 4;\n  grid-row: 1;\n}\n\n.layout-icon-surveillance .layout-icon-surv-stack:nth-child(3) {\n  grid-column: 4;\n  grid-row: 2;\n}\n\n.layout-icon-surveillance .layout-icon-surv-stack:nth-child(4) {\n  grid-column: 4;\n  grid-row: 3;\n}\n\n.layout-icon-surveillance .layout-icon-surv-bottom:nth-child(5) {\n  grid-column: 1;\n  grid-row: 4;\n}\n\n.layout-icon-surveillance .layout-icon-surv-bottom:nth-child(6) {\n  grid-column: 2;\n  grid-row: 4;\n}\n\n.layout-icon-surveillance .layout-icon-surv-bottom:nth-child(7) {\n  grid-column: 3;\n  grid-row: 4;\n}\n\n.layout-icon-surveillance .layout-icon-surv-bottom:nth-child(8) {\n  grid-column: 4;\n  grid-row: 4;\n}\n\n.layout-icon-cell {\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  min-height: 0;\n  border-radius: 1px;\n  background: currentColor;\n  opacity: 0.75;\n}\n\n.layout-btn.active .layout-icon-cell {\n  opacity: 1;\n}\n\n/* Camera selector */\n.camera-selector {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 15px;\n  padding: 10px;\n  background: rgba(255,255,255,0.03);\n  border-radius: 8px;\n}\n\n.selector-label {\n  color: #6b7280;\n  font-size: 13px;\n  margin-right: 8px;\n}\n\n.camera-chip {\n  background: rgba(255,255,255,0.08);\n  border: 1px solid rgba(255,255,255,0.1);\n  color: #9ca3af;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.camera-chip:hover {\n  background: rgba(255,255,255,0.15);\n  color: #fff;\n}\n\n.camera-chip.selected {\n  background: #3b82f6;\n  border-color: #3b82f6;\n  color: #fff;\n}\n\n.camera-chip.clear {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.3);\n  color: #fca5a5;\n}\n\n.camera-chip.clear:hover {\n  background: rgba(239, 68, 68, 0.3);\n}\n\n/* Video Grid — filas/columnas 1fr reparten el alto disponible; el vídeo rellena la celda (VideoCard). */\n.video-grid {\n  display: grid;\n  column-gap: 8px;\n  row-gap: 8px;\n  width: 100%;\n  max-width: 100%;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n  align-content: stretch;\n}\n\n/* Una sola cámara */\n.video-grid.layout-1 {\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr);\n  justify-items: stretch;\n  align-content: stretch;\n  min-height: 0;\n}\n.video-grid.layout-1 > * {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  max-width: 100%;\n  max-height: 100%;\n  aspect-ratio: unset;\n}\n\n/* ---------- Vista enfocada (doble clic en slot → 1x1) ---------- */\n\n/* El grid deja de recortar para que el slot enfocado pueda salir de él */\n.video-grid.video-grid-focused {\n  overflow: visible !important;\n}\n\n/* El slot enfocado se posiciona sobre .streams-view-right (el ancestro con position:relative)\n   porque .video-grid no tiene position, así que absolute va al siguiente ancestro posicionado. */\n.video-grid.video-grid-focused > .grid-slot-focused {\n  position: absolute !important;\n  inset: 0 !important;\n  z-index: 50;\n  width: auto !important;\n  height: auto !important;\n  aspect-ratio: auto !important;\n  min-height: 0 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  background: #1a1a1a;\n}\n\n/* VideoCard y video: llenan todo el slot enfocado */\n.video-grid.video-grid-focused > .grid-slot-focused > .video-card {\n  flex: 1 !important;\n  min-height: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.video-grid.video-grid-focused > .grid-slot-focused .video-container {\n  flex: 1 !important;\n  min-height: 0 !important;\n}\n\n/* Los demás slots quedan montados (videos cargados) pero invisibles */\n.video-grid.video-grid-focused > .grid-slot:not(.grid-slot-focused),\n.video-grid.video-grid-focused > .empty-slot:not(.grid-slot-focused) {\n  visibility: hidden !important;\n}\n\n/* Hint sobre el slot enfocado */\n.video-grid-focused-hint {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  pointer-events: none;\n  z-index: 51;\n}\n\n.video-grid.layout-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  grid-template-rows: repeat(2, minmax(0, 1fr));\n}\n\n.video-grid.layout-3x2 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  grid-template-rows: repeat(2, minmax(0, 1fr));\n}\n\n.video-grid.layout-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  grid-template-rows: repeat(3, minmax(0, 1fr));\n}\n\n.video-grid.layout-4x3 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-template-rows: repeat(3, minmax(0, 1fr));\n}\n\n.video-grid.layout-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-template-rows: repeat(4, minmax(0, 1fr));\n}\n\n/* Vista vigilancia: 1 principal (grande) + 3 apiladas derecha + 4 abajo */\n.video-grid.layout-surveillance {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-template-rows: repeat(3, minmax(0, 1fr)) minmax(0, 1fr);\n}\n\n.video-grid.layout-surveillance > * {\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.video-grid.layout-surveillance > *:nth-child(1) {\n  grid-column: 1 / 4;\n  grid-row: 1 / 4;\n}\n\n.video-grid.layout-surveillance > *:nth-child(2) {\n  grid-column: 4;\n  grid-row: 1;\n}\n\n.video-grid.layout-surveillance > *:nth-child(3) {\n  grid-column: 4;\n  grid-row: 2;\n}\n\n.video-grid.layout-surveillance > *:nth-child(4) {\n  grid-column: 4;\n  grid-row: 3;\n}\n\n.video-grid.layout-surveillance > *:nth-child(5) {\n  grid-column: 1;\n  grid-row: 4;\n}\n\n.video-grid.layout-surveillance > *:nth-child(6) {\n  grid-column: 2;\n  grid-row: 4;\n}\n\n.video-grid.layout-surveillance > *:nth-child(7) {\n  grid-column: 3;\n  grid-row: 4;\n}\n\n.video-grid.layout-surveillance > *:nth-child(8) {\n  grid-column: 4;\n  grid-row: 4;\n}\n\n.empty-slot {\n  background: var(--rx-slot);\n  border: 2px dashed var(--rx-border);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  transition: all 0.2s;\n}\n\n.empty-slot:hover {\n  border-color: var(--rx-accent);\n  background: rgba(166, 27, 52, 0.05);\n}\n\n.empty-slot-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px;\n  text-align: center;\n}\n\n.empty-slot-icon {\n  width: 48px;\n  height: 48px;\n  color: #4b5563;\n}\n\n.empty-slot-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.empty-slot-text {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.empty-slot-number {\n  font-size: 11px;\n  color: #6b7280;\n  margin-top: 4px;\n}\n\n/* Banner de cámaras disponibles (flotante, no ocupa espacio en el layout) */\n.cameras-banner {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 20;\n  width: 260px;\n  max-height: 200px;\n  background: #2d2d2d;\n  border: 1px solid #3d3d3d;\n  border-radius: 8px;\n  padding: 12px;\n  overflow-y: auto;\n  animation: slideDown 0.3s ease-out;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.banner-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.banner-header h3 {\n  margin: 0;\n  font-size: 14px;\n  color: #fff;\n  font-weight: 600;\n}\n\n.close-banner-btn {\n  background: transparent;\n  border: none;\n  color: #999;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.close-banner-btn:hover {\n  color: #fff;\n}\n\n.cameras-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 8px;\n}\n\n.camera-item {\n  background: #1a1a1a;\n  border: 1px solid #3d3d3d;\n  border-radius: 6px;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: grab;\n  transition: all 0.2s;\n}\n\n.camera-item:active {\n  cursor: grabbing;\n}\n\n.camera-item:hover {\n  border-color: #A61B34;\n  background: rgba(166, 27, 52, 0.05);\n}\n\n.camera-item-icon {\n  font-size: 24px;\n}\n\n.camera-item-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.camera-item-name {\n  font-weight: 600;\n  color: #fff;\n  font-size: 14px;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.camera-item-address {\n  color: #999;\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.camera-item-badge {\n  background: #3d3d3d;\n  color: #999;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.camera-item-badge--on {\n  background: rgba(34, 197, 94, 0.16);\n  color: #86efac;\n}\n\n.camera-item-badge--off {\n  background: rgba(220, 38, 38, 0.16);\n  color: #fca5a5;\n}\n\n.camera-item-badge--issue {\n  background: rgba(249, 115, 22, 0.16);\n  color: #fdba74;\n}\n\n.camera-item-badge--unknown {\n  background: rgba(107, 114, 128, 0.2);\n  color: #d1d5db;\n}\n\n.camera-item--off {\n  opacity: 0.78;\n}\n\n.camera-item--off .camera-item-name {\n  color: #d1d5db;\n}\n\n.grid-slot {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Solo slots con overlay bajo demanda: evita contain en todas las celdas con VideoCard */\n.grid-slot--on-demand-frozen {\n  container-type: size;\n  container-name: stream-slot;\n}\n\n/* remove-camera-btn moved into VideoCard header */\n\n.loading-cameras {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 20px;\n  min-height: 120px;\n}\n\n.no-cameras-found {\n  text-align: center;\n  padding: 40px 20px;\n  color: #999;\n  font-size: 14px;\n}\n\n/* Celdas: llenan la pista 1fr (el alto lo marca el contenedor, no aspect-ratio + max-height sueltos). */\n.video-grid:not(.layout-1):not(.layout-surveillance):not(.video-grid-focused) > * {\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  min-height: 0;\n  max-width: 100%;\n  max-height: 100%;\n  aspect-ratio: unset;\n  overflow: hidden;\n  box-sizing: border-box;\n  align-self: stretch;\n}\n\n@media (max-width: 1200px) {\n  .layout-controls {\n    flex-wrap: wrap;\n  }\n  \n  .layout-btn {\n    font-size: 12px;\n    padding: 5px 8px;\n    min-width: 35px;\n  }\n}\n\n@media (max-width: 768px) {\n  .streams-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .streams-header-left {\n    order: 1;\n  }\n\n  .streams-header-right {\n    order: 2;\n    width: 100%;\n  }\n\n  .streams-header-search {\n    max-width: none;\n    width: 100%;\n  }\n\n  .search-container {\n    flex: 1;\n    min-width: 0;\n    max-width: none;\n  }\n\n  .search-input {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .streams-view-right {\n    align-items: stretch;\n  }\n\n  .streams-header .layout-controls {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .streams-schema-sidebar {\n    --schema-width: min(86vw, 340px);\n    border-top-left-radius: 14px;\n    border-bottom-left-radius: 14px;\n  }\n\n  .streams-schema-toggle {\n    z-index: 10001;\n  }\n\n  .streams-schema-toggle.open {\n    right: min(86vw, 340px);\n  }\n}\n\n/* ── Overlay \"¿Quieres seguir viendo?\" (bajo demanda) ── */\n.on-demand-screenshot {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.on-demand-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(2px);\n  animation: onDemandFadeIn 0.4s ease;\n  box-sizing: border-box;\n  padding: 4px;\n  padding: clamp(2px, 1.2cqmin, 10px);\n  min-height: 0;\n}\n\n@keyframes onDemandFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.on-demand-overlay-content {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: space-between;\n  gap: 8px;\n  gap: clamp(4px, 1.5cqmin, 10px);\n  padding: 14px 16px;\n  padding: clamp(6px, 3cqmin, 24px) clamp(8px, 3.5cqmin, 28px);\n  text-align: center;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  max-height: 100%;\n  min-height: 0;\n}\n\n/* Texto e icono: zona que puede hacer scroll si el slot es muy bajo; botones quedan visibles abajo */\n.on-demand-overlay-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  gap: clamp(3px, 1.2cqmin, 10px);\n  scrollbar-width: thin;\n}\n\n.on-demand-overlay-icon {\n  width: 36px;\n  height: 36px;\n  width: clamp(22px, 10cqmin, 48px);\n  height: clamp(22px, 10cqmin, 48px);\n  flex-shrink: 0;\n  color: #dc2626;\n  margin-bottom: 0;\n}\n\n.on-demand-overlay-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.on-demand-overlay-site {\n  font-size: 13px;\n  font-size: clamp(10px, 2.8cqmin + 0.35rem, 16px);\n  font-weight: 700;\n  color: #dc2626;\n  max-width: 100%;\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-break: break-word;\n}\n\n.on-demand-overlay-text {\n  font-size: 12px;\n  font-size: clamp(9px, 2.2cqmin + 0.28rem, 13px);\n  color: #d1d5db;\n  line-height: 1.45;\n  max-width: 100%;\n  min-width: 0;\n  width: 100%;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  hyphens: auto;\n}\n\n.on-demand-overlay-question {\n  font-size: 12px;\n  font-size: clamp(10px, 2.4cqmin + 0.3rem, 14px);\n  font-weight: 600;\n  color: #fff;\n  max-width: 100%;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n\n.on-demand-overlay-actions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  gap: clamp(6px, 2cqmin, 10px);\n  flex-shrink: 0;\n  width: 100%;\n  margin-top: 0;\n}\n\n.on-demand-btn {\n  padding: 6px 14px;\n  padding: clamp(5px, 1.2cqmin, 8px) clamp(10px, 3cqmin, 20px);\n  border-radius: 8px;\n  border-radius: clamp(5px, 1cqmin, 8px);\n  font-size: 12px;\n  font-size: clamp(10px, 2.1cqmin + 0.25rem, 13px);\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: background 0.15s ease, transform 0.1s ease;\n  flex: 1 1 auto;\n  min-width: min(100%, 4.5em);\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Slots estrechos o bajos: botones en columna para no recortar */\n@container stream-slot (max-width: 260px) {\n  .on-demand-overlay-actions {\n    flex-direction: column;\n  }\n\n  .on-demand-btn {\n    width: 100%;\n    min-width: 0;\n    max-width: none;\n  }\n}\n\n@container stream-slot (max-height: 200px) {\n  .on-demand-overlay-actions {\n    flex-direction: column;\n  }\n\n  .on-demand-btn {\n    width: 100%;\n    min-width: 0;\n    max-width: none;\n  }\n}\n\n/* Muy poca altura: ocultar icono para priorizar texto + botones */\n@container stream-slot (max-height: 120px) {\n  .on-demand-overlay-icon {\n    display: none;\n  }\n\n  .on-demand-overlay-content {\n    gap: 4px;\n    padding: 4px 6px;\n  }\n}\n\n.on-demand-btn:active {\n  transform: scale(0.97);\n}\n\n.on-demand-btn-yes {\n  background: rgba(255, 255, 255, 0.12);\n  color: #d1d5db;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.on-demand-btn-yes:hover {\n  background: rgba(255, 255, 255, 0.25);\n  color: #fff;\n}\n\n.on-demand-btn-no {\n  background: rgba(255, 255, 255, 0.1);\n  color: #9ca3af;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.on-demand-btn-no:hover {\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
